/**
 * Connector Health (WP1-HEALTH): Settings, PulseSync. Each office's
 * connector with root-cause hints and freshness alarms, write-back
 * capabilities, sync parity charts, the conflict inbox, data ownership and the
 * S0 exit checklist (Migration Center v0). API: `/v1/connector-health`.
 */
import { defineManifest } from '@velora/contracts';
import { defineWebModule } from '../../app/module.js';

export default defineWebModule({
  manifest: defineManifest({
    id: 'connector-health',
    title: 'Connector health',
    version: '0.1.0',
    owner: 'WP1-HEALTH',
    entitlementKey: null,
    permissions: ['settings.manage', 'patient.view'],
    routes: [
      {
        id: 'connectors',
        path: '/settings/connectors',
        title: 'PulseSync connectors',
        officeScope: 'location-or-all',
        readsPhi: true,
      },
    ],
    nav: [
      {
        label: 'PulseSync',
        group: 'settings',
        routeId: 'connectors',
        icon: 'activity',
        order: 935,
        // The connector overview needs settings.manage; conflict links still open the page.
        permission: 'settings.manage',
      },
    ],
    commands: [
      {
        id: 'connector-health.open',
        title: 'PulseSync connectors',
        keywords: [
          'sync',
          'pms',
          'connector',
          'health',
          'freshness',
          'open dental',
          'dentrix',
          'eaglesoft',
        ],
        routeId: 'connectors',
      },
      {
        id: 'connector-health.conflicts',
        title: 'Conflict inbox',
        keywords: ['write-back', 'conflict', 'sync', 'pms'],
        routeId: 'connectors',
      },
      {
        id: 'connector-health.parity',
        title: 'Sync parity',
        keywords: ['parity', 'drift', 'migration', 'gate c'],
        routeId: 'connectors',
      },
    ],
    sseEntityKeys: ['conflict', 'pms_link', 'command'],
    phiReadPoints: ['conflict.inbox'],
  }),
  pages: {
    connectors: () => import('./ConnectorsPage.js'),
  },
});
